<page-headline
    [linkTitle]="'Financials Home'"
    [module]="'financials'"
    [moduleIcon]="'fa-dollar-sign'"
    [moduleLink]="'financials'"
    [pageTitle]="pageTitle"
>
</page-headline>

<div>
    <main-filters (filtersOutput)="applyNewFilters($event)"></main-filters>
    <div class="displayopt-actionpanel-layout">
        <display-options
                (displayOptionsOutput)="applyDisplayOptions($event)"
                [showCompareToDate]="true"
        >
        </display-options>
        <action-panel
                [showExportCsv]="false"
                [showSaveAsPdf]="true"
                [showPrint]="false"
                [title]="pageTitle"
        >
        </action-panel>
    </div>
</div>
<div class="row-layout-track layout-padding-bottom__1_5rem">
    <div *ngFor="let smallCard of financialsSmallCards" class="financials-small-card">
        <small-card
                [smallCardData]="smallCard.card"
                [hasBPS]="true"
                [hasDialog]="true"
                *ngIf="smallCard.card"
        ></small-card>
    </div>
</div>
<div class="row-layout-track">
    <div *ngFor="let largeCard of financialsLargeCards" class="largecard-layout-box__50">
        <large-card
                [largeCardInteriorOptions]="largeCard.largeCardInteriorOptions"
                [showMainValue]="false"
                [showDashboardTextRight]="false"
                [showDropdown]="false"
        ></large-card>
    </div>
</div>
